module.exports = __webpack_public_path__ + "static/heidi5-015e5e88040ee2ae9b384f55d57999c8.jpg";